








import { QueryActivityApplyList } from '@/api'
import { TableHander ,VTable} from '@/components/table'
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import HouseDescDialog from '@/views/house/HouseDescDialog.vue'
@Component({
  components: { HouseDescDialog,VTable },
})
export default class ActivityApplyInfoDialog extends Vue {
  private show = false
  private activeCode = ''
  private data: any = {}
  private queryParam = {
    startRow: 1,
    limit: 10,
  }

  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  
  @Emit('close')
  private close() {
    this.show = false
    this.data = {}
  }
  public open(data: any) {
    this.show = true
    this.data = data
    // 查询数据
    this.loadData()
  }

   // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 查询数据
  private async loadData(){
    const param: any = { activeCode: this.data.activeCode }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    param.limit = this.queryParam.limit
    const result = await QueryActivityApplyList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: 'ID', param: 'id',width: 50},
    { title: '用户编号', param: 'userNo',overflow:true },
    { title: '房子编号', param: 'houseCode',overflow:true,click: this.openHouseDesc },
    { title: '联系人姓名', param: 'name' },
    { title: '联系人电话', param: 'mobelPhone'},
    { title: '报名人数', param: 'applyNums'},
    { title: '报名时间', param: 'applyTime'},
    { title: '参会时间', param: 'mettingTime'},
  ]

  public openHouseDesc(houseCode: any){
    const d = this.$refs.houseDescDialog as HouseDescDialog
    d.open(houseCode)
  }
 
}
